import { useState } from 'react'

const useInputs = (initial) => {
  const [inputs, setInputs] = useState(initial || {})

  const onChangeInputs = ({ target, files }) => {
    if (target) {
      const name = target?.name
      const value = target?.value

      if (name) {
        const nameParts = name.split('.')

        const updatedInputs = { ...inputs }

        let currentObj = updatedInputs
        nameParts.forEach((part, index) => {
          if (!currentObj[part]) {
            currentObj[part] = {}
          }
          if (index === nameParts.length - 1) {
            currentObj[part] = value
          }
          currentObj = currentObj[part]
        })
        setInputs(updatedInputs)
      }
    }

    if (files) {
      setInputs({ ...inputs, files })
    }
  }

  const updateInputs = (data) => {
    setInputs(data)
  }

  return {
    inputs,
    onChangeInputs,
    updateInputs,
  }
}

export default useInputs
